import React from "react";
import android from "../../images/home/technology/android.svg";
import apple from "../../images/home/technology/apple.svg";
import react from "../../images/home/technology/react.svg";
import angular from "../../images/home/technology/angular.svg";
import dotnet from "../../images/home/technology/dotnet.svg";
import flutter from "../../images/home/technology/flutter.svg";
import php from "../../images/home/technology/php.svg";
import nodejs from "../../images/home/technology/nodejs.svg";
import xamarin from "../../images/home/technology/xamarin.svg";
import vuejs from "../../images/home/technology/vuejs.svg";
import { Link } from "react-router-dom";

const languageData = [
  {
    image: xamarin,
    heading: "Xamarin Developer",
    text: "3 to 5+ years",
  },
  {
    image: android,
    heading: "Android Developer",
    text: "3 to 5+ years",
  },
  {
    image: apple,
    heading: "iOS Developer",
    text: "3 to 5+ years",
  },
  {
    image: react,
    heading: "React.js Developer",
    text: "3 to 5+ years",
  },
  {
    image: react,
    heading: "React Native Developer",
    text: "3 to 5+ years",
  },
  {
    image: angular,
    heading: "Angular Developer",
    text: "3 to 5+ years",
  },
  {
    image: dotnet,
    heading: "Asp.Net Developer",
    text: "3 to 5+ years",
  },
  {
    image: flutter,
    heading: "Flutter Developer",
    text: "3 to 5+ years",
  },
  {
    image: php,
    heading: "Laravel Developer",
    text: "3 to 5+ years",
  },
  {
    image: nodejs,
    heading: "Node.js Developer",
    text: "3 to 5+ years",
  },
  {
    image: vuejs,
    heading: "Vue.js Developer",
    text: "3 to 5+ years",
  },
];

const ExplorePosition = () => {
  return (
    <>
      <section className="exploreSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  Explore <span>Remote Developer</span> Job
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            {languageData.map((each, i) => (
              <div
                className="col-md-4 col-sm-6 mb-4"
                data-aos="zoom-in"
                key={i}
              >
                <div className="techno">
                  <ul>
                    <li>
                      <img src={each.image} alt="ReactJS Developer" />
                      <h6>{each.heading}</h6>
                      <p>
                        Ex: <span>{each.text}</span>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
            <div className="col-md-4 col-sm-6 mb-4" data-aos="zoom-in">
              <div className="techno applyNow">
                <ul>
                  <li>
                    Looking for another remote job role?{" "}
                    <Link to="/GetHireDeveloper">Apply Now</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExplorePosition;
